import { Component, OnInit, ViewEncapsulation, Input, OnDestroy, EventEmitter, Output } from '@angular/core';
import { IdService } from '../../shared/services/id.service';
import { TMediaCardLayout, IMediaCardArticle } from './media-card.types';

@Component({
	selector: 'rbc-media-card',
	templateUrl: './media-card.component.html',
	styleUrls: ['./media-card.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class MediaCardComponent implements OnInit, OnDestroy {
	@Input() id: string;
	@Input() scrollMobile: boolean = false;
	@Input() linksAlignStart: boolean = false;
	@Input() divider: boolean = false;
	@Input() card: boolean = false;
	@Input() columns: string;
	@Input() layout: TMediaCardLayout;
	@Input() articles: IMediaCardArticle[];

	@Output() ctaLinkClicked = new EventEmitter();

	constructor(private idService: IdService) {}

	ngOnInit() {
		if (!this.id) {
			this.id = this.idService.generate();
		}
	}

	ngOnDestroy(): void {
		if (this.idService) {
			this.idService.remove(this.id);
		}
	}

	containerClasses() {
		const { layout, scrollMobile, articles } = this;
		return {
			row: this.columnsGen(),
			'media-card-tiles': layout === 'featured-tile',
			'media-card-featured-stacked': layout === 'featured-stacked',
			'media-card-featured-stacked-horizontal': layout === 'featured-stacked-horizontal',
			'media-card-scroll': articles && articles.length > 1 && scrollMobile
		};
	}

	columnsClasses(index) {
		const { layout, divider, card } = this;
		const columnResult = this.columnsGen();
		const columnResultIndex = this.columnsGen(index);

		return {
			[`col-lg-${12 / columnResultIndex}`]: columnResult,
			'col-md-6': columnResultIndex >= 2 && layout !== 'featured-stacked',
			'media-card-divider': !card && divider
		};
	}

	columnsGen(index?): any {
		const { layout, columns } = this;
		if (layout === 'featured-tile') {
			if (index === 0) {
				return 1.5;
			} else {
				return 3;
			}
		} else if (layout === 'featured-stacked') {
			return 2;
		} else if (layout === 'featured-stacked-horizontal') {
			return;
		} else if (columns) {
			return columns;
		} else {
			return;
		}
	}

	articleColoredClasses(article) {
		return {
			'media-card-colored-overlay-translucent': article.image,
			[`b-${article.backgroundColor}`]: article.backgroundColor
		};
	}

	articleImageClasses(article) {
		return {
			'media-card-image-content': !article.colored && (article.imageText || article.imageIcon),
			[`b-${article.imageBackgroundColor}`]: article.imageBackgroundColor,
			[`c-${article.imageTextColor}`]: article.imageTextColor
		};
	}

	articleCategoryClasses(article) {
		return {
			[`c-${article.categoryColor}`]: article.categoryColor
		};
	}

	cardTypeGen(index?) {
		const { articles, layout } = this;
		if (
			articles[index].stacked === 'horizontal' ||
			layout === 'stacked-horizontal' ||
			(layout === 'featured-stacked' && index !== 0) ||
			(layout === 'featured-stacked-horizontal' && index !== 0) ||
			(layout === 'featured-tile' && index === 0)
		) {
			return 'horizontal';
		} else {
			return 'vertical';
		}
	}

	generateInitials(name) {
		const fullName = name.split(' ').map(val => val.substring(0, 1));
		return fullName.join('');
	}

	linkClicked(article) {
		this.ctaLinkClicked.emit(article);
	}
}
